export const figure18c
 = {
  chart: {
      type: 'line',
      backgroundColor: 'rgba(255, 255, 255, 0.0)',
         height: 230,
      plotBackgroundColor: null,
      plotBorderWidth: null,
    },
    credits: {
      enabled: false
  },
    title: {
      text: 'Malawi'
    },
    subtitle: {
      text: null
  },
    xAxis: {
      categories: ['2004','2011','2013','2017', '2020']
    },
    labels: {
      	style: {
        fontWeight: 'normal',
        color: '#999999',
        fontSize: '12px'
      },
    },
    yAxis: {
      min: 0,
      max: 2000,
      tickInterval: 500,
      title: {
          text: null,
      },
    },
    plotOptions: {
      line: {
        dataLabels: {
          enabled: false
        },
        enableMouseTracking: true
      }
    },
    legend: {
      enabled: false,
  },
    colors: ['#5b9bd5', '#ed7d32','#cbcccb', '#ffc100'],
    series: [{
      name: 'Petites exploitations',
      data: [144, 281, 621, 374, 496,]
    }, {
      name: 'Autres exploitations',
      data: [241, 466, 1457, 591, 611,]
    },{
      name: 'Petites exploitations dirigées par une femme',
      data: [120, 243, 546, 331, 399, ]
    },{
      name: 'Petites exploitations dirigées par un homme',
      data: [154, 297, 653, 399, 555,]
    }]
  }

  